import { Modal } from "antd";
import React from "react";
import translator from "../utilities/translator";
import DocumentViewer from "./DocumentViewer";
import ExamShareModal from "../components/base/ExamShareModal";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReportViewer from "./ReportViewer";

import { xhrClinicalGetExamStudyByExamId } from "../utilities/xhr-clinical";
import { xhrInstGetEquipmentsAll } from "../utilities/xhr-inst";

import toastUtil from "../utilities/toast-util";
import { xhrApiGetToken } from "../utilities/xhr-api";
import { formattedDate, formattedDateTime } from "../utilities/dateFormatter";

function ExamBottomSection({
	exclude,
	selectedExam,
	bundledExams,
	updateExams,
}) {
	const history = useHistory();

	const [showMatchingModal, setShowMatchingModal] = React.useState(false);
	const [showDocumentsModal, setShowDocumentsModal] = React.useState(false);
	const [showChangeStatusModal, setShowChangeStatusModal] =
		React.useState(false);
	const [showReportViewModal, setShowReportViewModal] = React.useState(false);
	const currentLanguage = useSelector(
		(state) => state.session.userPreferences?.language
	);
	const [showExamShareModal, setShowExamShareModal] = React.useState(false);
	let selectedExamObj = selectedExam;
	const token = useSelector((state) => state.session.token);
	const userInfo = useSelector((state) => state.session.userInfo);

	const userPermissions = useSelector((state) => state.session.userPermissions);

	const [ExamStudyByExamId, setExamStudyByExamId] = React.useState([]);
	const [selectedPrinter, setSelectedPrinter] = React.useState();
	const [printersByInstId, setPrintersByInstId] = React.useState([]);

	const [selectedEquipment, setSelectedEquipment] = React.useState();
	const [equipmentsByInstId, setEquipmentsByInstId] = React.useState([]);

	React.useEffect(() => {
		let mountedRef = true;
		if (selectedExamObj?.instId) {
			const effectPromise = async () => {
				var data = await xhrInstGetEquipmentsAll(token, {
					flt: "instId=" + selectedExamObj.instId,
				});
				toastUtil({ currentLanguage, data });
				if (!mountedRef) return null;
				setPrintersByInstId(
					data?.result?.data?.filter((x) => x.printer === true)
				);
				if (
					data?.result?.data?.filter(
						(x) => x.printer === true && x.isDefault == true
					)?.length > 0
				) {
					setSelectedPrinter(
						data?.result?.data?.filter(
							(x) => x.printer === true && x.isDefault == true
						)[0]
					);
				} else if (
					data?.result?.data?.filter((x) => x.printer === true)?.length > 0
				) {
					setSelectedPrinter(
						data?.result?.data?.filter((x) => x.printer === true)[0]
					);
				}

				setEquipmentsByInstId(
					data?.result?.data?.filter((x) => x.recorder === true)
				);
				if (
					data?.result?.data?.filter(
						(x) => x.recorder === true && x.isDefault == true
					)?.length > 0
				) {
					setSelectedEquipment(
						data?.result?.data?.filter(
							(x) => x.recorder === true && x.isDefault == true
						)[0]
					);
				} else if (
					data?.result?.data?.filter((x) => x.recorder === true)?.length > 0
				) {
					setSelectedEquipment(
						data?.result?.data?.filter((x) => x.recorder === true)[0]
					);
				}
			};
			effectPromise();
		}
		return () => {
			mountedRef = false;
		};
	}, [selectedExamObj?.instId]);

	React.useEffect(() => {
		let mountedRef = true;
		if (bundledExams?.length > 0) {
			const effectPromise = async () => {
				var studies = [];
				for (let index = 0; index < bundledExams.length; index++) {
					const element = bundledExams[index];
					var data = await xhrClinicalGetExamStudyByExamId(token, element.id);
					toastUtil({ currentLanguage, data });
					studies = studies.concat(
						data?.result?.data?.filter((e) => e.active === true)
					);
				}
				if (!mountedRef) return null;
				setExamStudyByExamId(studies);
			};
			effectPromise();
		} else {
			setExamStudyByExamId([]);
		}
		return () => {
			mountedRef = false;
		};
	}, [bundledExams, showMatchingModal]);

	return (
		<div style={{ marginRight: "8px", borderTop: "5px solid #e5e5e5" }}>
			<div>
				<ExamShareModal
					showExamShareModal={showExamShareModal}
					setShowExamShareModal={setShowExamShareModal}
					currentSelectedExam={selectedExamObj}
					onCancel={() => {
						setShowExamShareModal(false);
					}}
					bodyStyle={{
						padding: "20px 24px",
						height: "auto",
						maxHeight: "70vh",
						overflowY: "auto",
						borderRadius: "12px",
					}}
				/>
				<Modal
					open={showReportViewModal}
					title="Report"
					onOk={() => setShowReportViewModal(null)}
					onCancel={() => setShowReportViewModal(null)}
					zIndex={5000}
					className="custom-modal matching-modal headerborder-0 modal-width modal-dialog"
					width="1000px"
				>
					<div style={{ height: "70vh" }}>
						<ReportViewer reportId={showReportViewModal} />
					</div>
				</Modal>
				{/* ====== DOCUMENTS MODAL GOES HERE ====== */}
				<Modal
					open={showDocumentsModal}
					title={translator(currentLanguage, "documents")}
					onOk={() => setShowDocumentsModal(false)}
					onCancel={() => setShowDocumentsModal(false)}
					zIndex={5000}
					className="custom-modal matching-modal headerborder-0 modal-width modal-dialog"
					width="1000px"
				>
					<DocumentViewer bundledExams={bundledExams} />
				</Modal>
			</div>

			<div
				className="col-lg-12 col-md-8 d-flex flex-row align-items-center justify-content-between flex-wrap section-btmback bg-white"
				style={{ padding: "0.3rem" }}
			>
				<div
					className="d-flex flex-row align-items-center flex-wrap"
					style={{ flex: "1 1 33%", justifyContent: "flex-start" }}
				>
					{selectedExamObj && (
						<>
							{Boolean(selectedExamObj?.patId) &&
								!(exclude ?? []).includes("patient") && (
									<button
										className="btn  action-btn orange-base text-white border-0 ml-2 capital "
										style={{
											display: "flex",
											alignItems: "center",
											gap: "6px",
											fontSize: "14px",
											fontWeight: 600,
											padding: "8px 16px",
											background:
												"linear-gradient(90deg, #E78E4A 0%, #C16427 100%)",
											borderRadius: "8px",
											boxShadow: "0 2px 6px rgba(231, 142, 74, 0.4)",
											transition: "all 0.25s ease",
											cursor: "pointer",
										}}
										onMouseEnter={(e) => {
											e.currentTarget.style.background =
												"linear-gradient(90deg, #EDB994 0%, #E78E4A 100%)";
											e.currentTarget.style.boxShadow =
												"0 4px 10px rgba(231, 142, 74, 0.5)";
										}}
										onMouseLeave={(e) => {
											e.currentTarget.style.background =
												"linear-gradient(90deg, #E78E4A 0%, #C16427 100%)";
											e.currentTarget.style.boxShadow =
												"0 2px 6px rgba(231, 142, 74, 0.4)";
										}}
										onMouseDown={(e) => {
											e.currentTarget.style.transform = "scale(0.97)";
										}}
										onMouseUp={(e) => {
											e.currentTarget.style.transform = "scale(1)";
										}}
										onClick={async () => {
											console.log(selectedExamObj);
											history.push(`/patient/${selectedExamObj.patId}`);
										}}
										title={translator(currentLanguage, "patient")}
									>
										<i
											className="zmdi zmdi-account-calendar"
											style={{
												fontSize: "1.4em",
												position: "relative",
												top: "1px",
											}}
										></i>
										{translator(currentLanguage, "patient")}
									</button>
								)}

							{ExamStudyByExamId?.length > 0 && (
								<div className="hoverTopArea">
									<button
										className="btn  action-btn orange-base text-white border-0 ml-2 capital"
										style={{
											display: "flex",
											alignItems: "center",
											gap: "6px",
											fontSize: "14px",
											fontWeight: 600,
											padding: "8px 16px",
											background:
												"linear-gradient(90deg, #E78E4A 0%, #C16427 100%)",
											borderRadius: "8px",
											boxShadow: "0 2px 6px rgba(231, 142, 74, 0.4)",
											transition: "all 0.25s ease",
											cursor: "pointer",
										}}
										onMouseEnter={(e) => {
											e.currentTarget.style.background =
												"linear-gradient(90deg, #EDB994 0%, #E78E4A 100%)";
											e.currentTarget.style.boxShadow =
												"0 4px 10px rgba(231, 142, 74, 0.5)";
										}}
										onMouseLeave={(e) => {
											e.currentTarget.style.background =
												"linear-gradient(90deg, #E78E4A 0%, #C16427 100%)";
											e.currentTarget.style.boxShadow =
												"0 2px 6px rgba(231, 142, 74, 0.4)";
										}}
										onMouseDown={(e) => {
											e.currentTarget.style.transform = "scale(0.97)";
										}}
										onMouseUp={(e) => {
											e.currentTarget.style.transform = "scale(1)";
										}}
										onClick={async (e) => {
											e.preventDefault();
											window.open(
												"/img/" +
													selectedExamObj?.tenantId +
													"/" +
													ExamStudyByExamId?.map((x) => {
														return x.studyUid;
													}).join(";") +
													"/" +
													selectedExamObj?.tecAreaCode,
												"_blank"
											);
										}}
										title={translator(currentLanguage, "images")}
									>
										<i
											className="zmdi zmdi-image"
											style={{
												fontSize: "1.4em",
												position: "relative",
												top: "1px",
											}}
											title={translator(currentLanguage, "has_images")}
										></i>

										{translator(currentLanguage, "images")}
									</button>
									<div
										className="hoverTopPanel"
										style={{
											position: "absolute",
											top: "-39px",
											left: "30px",
											background: "white",
											padding: "4px",
											border: "1px solid green",
											borderRadius: "4px",
										}}
									>
										<button
											className="btn  action-btn orange-base text-white border-0 capital"
											style={{
												display: "inline-flex",
												alignItems: "center",
												justifyContent: "center",
												fontSize: "14px",
												fontWeight: 400,
												width: "32px",
												height: "32px",
												background:
													"linear-gradient(90deg, #E78E4A 0%, #C16427 100%)",
												borderRadius: "8px",
												boxShadow: "0 2px 6px rgba(231, 142, 74, 0.4)",
												transition: "all 0.25s ease",
												cursor: "pointer",
												padding: 0,
											}}
											onMouseEnter={(e) => {
												e.currentTarget.style.background =
													"linear-gradient(90deg, #EDB994 0%, #E78E4A 100%)";
												e.currentTarget.style.boxShadow =
													"0 4px 10px rgba(231, 142, 74, 0.5)";
											}}
											onMouseLeave={(e) => {
												e.currentTarget.style.background =
													"linear-gradient(90deg, #E78E4A 0%, #C16427 100%)";
												e.currentTarget.style.boxShadow =
													"0 2px 6px rgba(231, 142, 74, 0.4)";
											}}
											onMouseDown={(e) => {
												e.currentTarget.style.transform = "scale(0.97)";
											}}
											onMouseUp={(e) => {
												e.currentTarget.style.transform = "scale(1)";
											}}
											onClick={async (e) => {
												e.preventDefault();

												var data = await xhrApiGetToken(
													token,
													selectedExamObj?.tenantId
												);
												ExamStudyByExamId?.map((x) => {
													return x.studyUid;
												}).forEach((record) => {
													//debugger
													document.dispatchEvent(
														new CustomEvent("medapp_image_download", {
															bubbles: true,
															detail: {
																uri:
																	"https://wado.centro2s.com/api/Studies/" +
																	record +
																	"/DownloadStudy",
																token: data?.result?.data,
																name:
																	selectedExamObj?.patIdent +
																	"_" +
																	selectedExamObj?.productName +
																	"_" +
																	formattedDate(selectedExamObj?.planDatetime),
															},
														})
													);
												});
											}}
											title={translator(currentLanguage, "download")}
										>
											<i
												className="zmdi zmdi-download"
												style={{
													fontSize: "1.4em",
													position: "relative",
													top: "2px",
												}}
											></i>
										</button>
									</div>
								</div>
							)}
							<button
								className="btn  action-btn orange-base text-white border-0 ml-2 capital"
								style={{
									display: "flex",
									alignItems: "center",
									gap: "6px",
									fontSize: "14px",
									fontWeight: 600,
									padding: "8px 16px",
									background:
										"linear-gradient(90deg, #E78E4A 0%, #C16427 100%)",
									borderRadius: "8px",
									boxShadow: "0 2px 6px rgba(231, 142, 74, 0.4)",
									transition: "all 0.25s ease",
									cursor: "pointer",
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.background =
										"linear-gradient(90deg, #EDB994 0%, #E78E4A 100%)";
									e.currentTarget.style.boxShadow =
										"0 4px 10px rgba(231, 142, 74, 0.5)";
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.background =
										"linear-gradient(90deg, #E78E4A 0%, #C16427 100%)";
									e.currentTarget.style.boxShadow =
										"0 2px 6px rgba(231, 142, 74, 0.4)";
								}}
								onMouseDown={(e) => {
									e.currentTarget.style.transform = "scale(0.97)";
								}}
								onMouseUp={(e) => {
									e.currentTarget.style.transform = "scale(1)";
								}}
								onClick={async () =>
									setShowReportViewModal(selectedExamObj?.reportId)
								}
								title={translator(currentLanguage, "report")}
							>
								<i
									className="zmdi zmdi-file"
									style={{
										fontSize: "1.4em",
										position: "relative",
										top: "1px",
									}}
								></i>

								{translator(currentLanguage, "report")}
							</button>
							<button
								className="btn  action-btn orange-base text-white border-0 ml-2 capital"
								style={{
									display: "flex",
									alignItems: "center",
									gap: "6px",
									fontSize: "14px",
									fontWeight: 600,
									padding: "8px 16px",
									background:
										"linear-gradient(90deg, #E78E4A 0%, #C16427 100%)",
									borderRadius: "8px",
									boxShadow: "0 2px 6px rgba(231, 142, 74, 0.4)",
									transition: "all 0.25s ease",
									cursor: "pointer",
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.background =
										"linear-gradient(90deg, #EDB994 0%, #E78E4A 100%)";
									e.currentTarget.style.boxShadow =
										"0 4px 10px rgba(231, 142, 74, 0.5)";
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.background =
										"linear-gradient(90deg, #E78E4A 0%, #C16427 100%)";
									e.currentTarget.style.boxShadow =
										"0 2px 6px rgba(231, 142, 74, 0.4)";
								}}
								onMouseDown={(e) => {
									e.currentTarget.style.transform = "scale(0.97)";
								}}
								onMouseUp={(e) => {
									e.currentTarget.style.transform = "scale(1)";
								}}
								onClick={(e) => {
									e.preventDefault();
									setShowExamShareModal(true);
								}}
								title={translator(currentLanguage, "share")}
							>
								<i
									className="zmdi zmdi-share"
									style={{
										fontSize: "1.4em",
										position: "relative",
										top: "1px",
									}}
								></i>
								{translator(currentLanguage, "share")}
							</button>
						</>
					)}
				</div>

				{selectedExam && selectedExamObj?.id ? (
					<div
						className="d-flex flex-row align-items-center justify-content-end flex-wrap"
						style={{ flex: "1 1 33%" }}
					>
						{
							<button
								className="btn  action-btn orange-base text-white border-0 ml-2 capital"
								style={{
									display: "flex",
									alignItems: "center",
									gap: "6px",
									fontSize: "14px",
									fontWeight: 600,
									padding: "8px 16px",
									background:
										"linear-gradient(90deg, #E78E4A 0%, #C16427 100%)",
									borderRadius: "8px",
									boxShadow: "0 2px 6px rgba(231, 142, 74, 0.4)",
									transition: "all 0.25s ease",
									cursor: "pointer",
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.background =
										"linear-gradient(90deg, #EDB994 0%, #E78E4A 100%)";
									e.currentTarget.style.boxShadow =
										"0 4px 10px rgba(231, 142, 74, 0.5)";
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.background =
										"linear-gradient(90deg, #E78E4A 0%, #C16427 100%)";
									e.currentTarget.style.boxShadow =
										"0 2px 6px rgba(231, 142, 74, 0.4)";
								}}
								onMouseDown={(e) => {
									e.currentTarget.style.transform = "scale(0.97)";
								}}
								onMouseUp={(e) => {
									e.currentTarget.style.transform = "scale(1)";
								}}
								onClick={async () => {
									history.push({
										pathname: `/exam-review/${selectedExamObj.id}`,
										state: {
											examsSecondary: bundledExams?.map((x) => {
												return x.id;
											}),
										},
									});
								}}
								title={translator(currentLanguage, "open")}
							>
								<i
									className="zmdi zmdi-eye"
									style={{
										fontSize: "1.4em",
										position: "relative",
										top: "1px",
									}}
								></i>
								{translator(currentLanguage, "open")}
							</button>
						}
					</div>
				) : null}
			</div>
		</div>
	);
}

export default ExamBottomSection;
